module.exports = __webpack_public_path__ + "a768e7de/img/trash-icon.ff8201c7.svg";